// #### Recipes ####
export const IoMRequestsRegistryRecipe = {
    $type$: 'Recipe',
    name: 'IoMRequestsRegistry',
    rule: [
        {
            itemprop: 'appId',
            itemtype: { type: 'string', regexp: /^one.iom$/ },
            isId: true
        },
        {
            itemprop: 'requests',
            itemtype: {
                type: 'set',
                item: { type: 'referenceToObj', allowedTypes: new Set(['IoMRequest']) }
            }
        }
    ]
};
export default [IoMRequestsRegistryRecipe];
//# sourceMappingURL=IoMRequestsRegistry.js.map